// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qTw9","col":"styles_col__eRm4X"};